<template>

  <div class="mb-2">

    <label v-if="label !== ''">{{label}}</label>

    <vue-editor
        :required="required"
        :disabled="status === 'sending' || disabled"
        id="editor-sm"
        :editorToolbar="smallToolbar"
        :class="{'form-disabled':status === 'sending'}"
        :maxLength="maxLength"
        v-model="innerValue">
    </vue-editor>

  </div>


</template>
<script>
import {VueEditor} from "vue2-editor";

export default {
  /*todo: falta implementar outros tamanhos e tratar a questão das imagens assim como já ocorre em Comment, além disso implementar required que por enquanto será feito via back-end ou diretamente*/
  name: 't-editor',
  components: {VueEditor},
  data() {
    return {
      innerValue: "",
      smallToolbar: [
        [{color: []},"bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote","link"]
      ],
    }
  },
  props: {
    label:{
      type: String,
      default: ""
    },
    maxLength: {
      type: Number,
      default: null, // sem limite se não informado
    },
    value: {
      type: null,
      default: ""
    },
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: "",
    },
    command: {
      type: String,
      default: "insert",
    },
    small:Boolean,
  },
  mounted() {
    this.setValue(this.value)
  },
  methods: {
    setValue(v) {
      this.innerValue = v
    }
  },
  watch: {

    value(v) {
      this.setValue(v)
    },
    innerValue(value) {
      this.$emit("input", value)
    }
  }
}
</script>